var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex box-cover display-box",class:_vm.contentClass},[(_vm.cardContent)?[_c('div',{staticClass:"card w-100 h-100 p-1"},[_vm._t("default")],2)]:[_vm._t("default")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }